export const getIsSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
